// extracted by mini-css-extract-plugin
module.exports = {"broken-background":"ErrorPage_broken-background__b9Vnf","root":"ErrorPage_root__tSEg8"};